module.exports = __webpack_public_path__ + "static/media/spendlogs-logo-white.03306f09.svg";